import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { ServiceTemplateModel } from "../../models/ServiceTemplateModel";
import Stepper from "../../../../shared/components/Stepper/Stepper.vue";
import {
  SERVICE_TEMP_EVENTS,
  SERVICE_TEMP_CONSTANTS,
  MOVIL_VIEW_STEPPER_STYLE
} from "../../constants/ServiceTemplateConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FORM_CONSTANTS } from "@/shared/constants/FormConstants";

Vue.use(Vuetify);
@Component({
  name: "StepperViewer",
  components: {
    Stepper
  }
})
export default class StepperViewer extends Vue {
  @Prop() private dialogStepperViewer!: boolean;
  @Prop() private serviceTemplateData!: ServiceTemplateModel;

  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  switchClass = STYLE_CLASSES.SWITCH;

  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  STATE_TEXT = SERVICE_TEMP_CONSTANTS.LABEL.STATE;
  DATE_CREATED_TEXT = SERVICE_TEMP_CONSTANTS.LABEL.DATE_CREATED;
  DATE_CHANGED_TEXT = SERVICE_TEMP_CONSTANTS.LABEL.DATE_CHANGED;
  DESCRIPTION_TEXT = SERVICE_TEMP_CONSTANTS.LABEL.DESCRIPTION;
  MOBILE_PREVIEW = FORM_CONSTANTS.LABEL.MOBILE_PREVIEW;
  MOBILE_STYLE = FORM_CONSTANTS.MOBILE_STYLE;
  TITLE = FORM_CONSTANTS.PREVIEW_TEXT;
  VERSION_TEXT = SERVICE_TEMP_CONSTANTS.LABEL.VERSION;
  mobileView = false;

  created() {
    window.addEventListener("resize", this.removeMobileSet);
  }

  destroyed() {
    window.removeEventListener("resize", this.removeMobileSet);
  }

  removeMobileSet() {
    if (window.innerWidth < 960 && this.mobileView) {
      this.mobileView = false;
      const prev = this.$refs.stepperViewerDiv as HTMLDivElement;
      prev.clientWidth / 0.6;
    }
  }

  close() {
    this.mobileView = false;
    this.$emit(SERVICE_TEMP_EVENTS.CLOSE_STEPPER_VIEWER);
  }

  changeStyle() {
    if (this.mobileView) {
      const prev = this.$refs.stepperViewerDiv as HTMLDivElement;
      const widthStyle = prev.clientWidth * 0.6;
      return this.MOBILE_STYLE + `${widthStyle}px;` + MOVIL_VIEW_STEPPER_STYLE;
    }
  }
}
